import {trigger} from './lang.js';

export const trig = (args) => {
    let [stepData, stepNumber, time] = args;
    return trigger({
        stepData, stepNumber, time});
};
